import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image';
import React, { useEffect, useContext } from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { PopUpView } from '../../../../organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import FoodItemListHandlers from 'organisms/CartPage/Presentation/ReusableComponents/FoodItemListHandlers';
import { UserOrderContext } from 'context/context';
import { getTernaryValue } from 'common/utilities/utils';
function AlertForm({
  contentMsg = '',
  title = '',
  splitTitle,
  imageSrc,
  altText,
  confirmButtonText = '',
  confirmButtonClassName = '',
  confirmHandler,
  cancelButtonText = '',
  cancelHandler,
  buttonContainerClass = '',
  imageClassName = '',
  alertLocation = '',
  secondaryButtonType,
  contentImg,
  giftCardOrVoucherErrMsg,
  giftCardErrFirstMsg,
}) {
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  useEffect(() => {
    if (splitTitle) {
      PopUpView({
        popupTitle:
          translateWithI18Next(splitTitle.MSGTXT1) +
          translateWithI18Next(splitTitle.MSGTXT2) +
          translateWithI18Next(splitTitle.MSGTXT3),
      });
    } else if (contentMsg) {
      PopUpView({ popupTitle: contentMsg });
    } else if (!splitTitle) {
      PopUpView({ popupTitle: title });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, contentMsg]);
  useEffect(() => {
    return () => {
      const { showCartAlert } = FoodItemListHandlers(
        undefined,
        undefined,
        undefined,
        undefined,
        userOrderStateDispatch,
        undefined,
        undefined,
      );
      showCartAlert(false);
    };
  }, [userOrderStateDispatch]);
  return (
    <div className='alert-model-view-root' data-testid='alert-form'>
      {imageSrc ? (
        <ImageComponent className={imageClassName} data-testid='alert-form-image' srcFile={imageSrc} alt={altText} />
      ) : null}
      {splitTitle ? (
        <div className='alert-title' data-testid='split-msg'>
          <span>{translateWithI18Next(splitTitle.MSGTXT1)}</span>
          <span className='alert-red-text'>{translateWithI18Next(splitTitle.MSGTXT2)}</span>
          <span>{translateWithI18Next(splitTitle.MSGTXT3)}</span>
        </div>
      ) : (
        <span className='alert-title' data-testid='alert-form-title'>
          {title}
        </span>
      )}

      {giftCardErrFirstMsg && giftCardOrVoucherErrMsg ? (
        <>
          <span className={`alert-content ${alertLocation}`} data-test-id='alert-form-content'>
            {giftCardErrFirstMsg}
          </span>
          <span className={`alert-content alert-voucher-content ${alertLocation}`} data-test-id='alert-form-content'>
            {giftCardOrVoucherErrMsg}
          </span>
        </>
      ) : null}
      {contentMsg ? (
        <span className={`alert-content ${alertLocation}`} data-test-id='alert-form-content'>
          {contentMsg}
        </span>
      ) : null}

      {contentImg && (
        <ImageComponent className={imageClassName} data-testid='alert-form-image' srcFile={contentImg} alt={altText} />
      )}

      <div className={`alert-action-container ${buttonContainerClass}`}>
        {cancelHandler && (
          <ContainedButton
            ariaLable=''
            data-testid='alert-cancel-button'
            variant={ButtonType.tertiary}
            onClickHandler={cancelHandler}
          >
            {cancelButtonText}
          </ContainedButton>
        )}
        {confirmHandler && (
          <ContainedButton
            ariaLable=''
            data-testid='alert-confirm-button'
            className={confirmButtonClassName}
            variant={getTernaryValue(secondaryButtonType, secondaryButtonType, ButtonType.secondary)}
            onClickHandler={confirmHandler}
          >
            {confirmButtonText}
          </ContainedButton>
        )}
      </div>
    </div>
  );
}

export default AlertForm;
